import {createContext, useEffect, useState} from "react";
import {Drawer, Stack} from "@mui/joy";
import {useLocation} from "react-router-dom";
import {SidebarContent} from "../components/layout/Sidebar";

export type SideNavigationContextState = {
    drawerOpen?: boolean
    setDrawerOpen?: (open: boolean) => void
}

export const ISideNavigationContext = createContext<SideNavigationContextState>({})

const SideNavigationContext = (props: { children }) => {
    const [drawerOpen, setDrawerOpen] = useState(false)
    const location = useLocation()

    // Picking a destination in the drawer is the end of what it was opened for
    useEffect(() => setDrawerOpen(false), [location.pathname])

    return <ISideNavigationContext.Provider value={{drawerOpen, setDrawerOpen}}>
        <Drawer
            anchor={"left"}
            open={drawerOpen}
            size={"md"}
            onClose={() => setDrawerOpen(false)}>
            <Stack>
                <SidebarContent/>
            </Stack>
        </Drawer>
        {props.children}
    </ISideNavigationContext.Provider>
}

export default SideNavigationContext
